export const ERROR_DEFAULT = 'Oops, something went wrong! Try again.';
export const ERROR_TAKEN_EMAIL = 'Oops, this email is already taken by another user.';
export const SUCCESS_UPDATE_DEFAULT = 'Success! Your changes have been saved!';
